import { gql } from "@apollo/client";

export const UPDATE_ADMIN_REQUEST = gql`
  mutation updateAdminRequestStatus($updateAdminReqStatusInput: UpdateAdminReqStatusInput!) {
    updateAdminRequestStatus(updateAdminReqStatusInput: $updateAdminReqStatusInput) {
      status
    }
  }
`;
